
import { computed, defineComponent, PropType } from "vue";
import InputFieldFeedbackStatus from "../enum/InputFieldFeedbackStatus.enum";
import FormFieldInputConfig from "../interfaces/config/FormFieldInputConfig.interface";
export default defineComponent({
  name: "BaseFormFieldComponent",
  props: {
    config: {
      type: Object as PropType<FormFieldInputConfig>,
      required: true,
    },
  },
  setup(props) {
    const isSuccess = computed(
      () => props.config.feedbackStatus === InputFieldFeedbackStatus.SUCCESS
    );

    const isError = computed(
      () => props.config.feedbackStatus === InputFieldFeedbackStatus.ERROR
    );

    return {
      isSuccess,
      isError,
    };
  },
});
